<div *ngIf="products?.length" class="similar-products">
  <div class="text_heading-5 text_color-05">{{ 'components.similarProducts.label.title' | translate }}</div>

  <div class="similar-products__items">
    <lp-product-card *ngFor="let product of products" [product]="product" [showIsFavorite]="true"></lp-product-card>
  </div>
</div>
